export default __webpack_public_path__ + "static/media/mouse.e802faed.png";